import { HugeiconsIcon } from '@hugeicons/react'
import {
  Building03Icon,
  DashboardSquare01Icon,
  FullScreenIcon,
  Image02Icon,
  InformationCircleIcon,
  RunningShoesIcon,
  Sun03Icon,
} from '@hugeicons/core-free-icons'

import Dock, { type DockItemData } from '@/components/Dock'
import { useAppStore } from '@/store'

// The seven scene tools, on Tower's magnifying dock. Which tools exist is
// Diriyah's business; how the dock looks and feels is Tower's, so the component
// comes across untouched and only the items differ.
export function SceneDock() {
  const tool = useAppStore((s) => s.tool)
  const toggleTool = useAppStore((s) => s.toggleTool)
  const markers = useAppStore((s) => s.markers)
  const setMarkers = useAppStore((s) => s.setMarkers)
  const enterWalk = useAppStore((s) => s.enterWalk)
  const walking = useAppStore((s) => s.walking)

  if (walking) return null

  const items: DockItemData[] = [
    {
      icon: <HugeiconsIcon icon={Building03Icon} size={19} strokeWidth={2} />,
      label: 'Residences',
      onClick: () => toggleTool('residences'),
      className: tool === 'residences' ? 'ring-2 ring-primary' : undefined,
    },
    {
      icon: <HugeiconsIcon icon={RunningShoesIcon} size={19} strokeWidth={2} />,
      label: 'Walk through',
      onClick: enterWalk,
    },
    {
      icon: <HugeiconsIcon icon={DashboardSquare01Icon} size={19} strokeWidth={2} />,
      label: markers ? 'Hide markers' : 'Show markers',
      onClick: () => setMarkers(!markers),
      className: markers ? 'ring-2 ring-primary' : undefined,
    },
    {
      icon: <HugeiconsIcon icon={Sun03Icon} size={19} strokeWidth={2} />,
      label: 'Time of day',
      onClick: () => toggleTool('time'),
      className: tool === 'time' ? 'ring-2 ring-primary' : undefined,
    },
    {
      icon: <HugeiconsIcon icon={Image02Icon} size={19} strokeWidth={2} />,
      label: 'Interiors',
      onClick: () => toggleTool('interiors'),
      className: tool === 'interiors' ? 'ring-2 ring-primary' : undefined,
    },
    {
      icon: <HugeiconsIcon icon={InformationCircleIcon} size={19} strokeWidth={2} />,
      label: 'Project info',
      onClick: () => toggleTool('info'),
      className: tool === 'info' ? 'ring-2 ring-primary' : undefined,
    },
    {
      icon: <HugeiconsIcon icon={FullScreenIcon} size={19} strokeWidth={2} />,
      label: 'Fullscreen',
      onClick: () => {
        if (document.fullscreenElement) void document.exitFullscreen()
        else void document.documentElement.requestFullscreen()
      },
    },
  ]

  return (
    // The bar itself must not eat pointer events — it spans the full width and
    // would swallow every drag meant for the camera. Only the dock re-enables
    // them, which is why the auto sits on the inner wrapper and not out here.
    <nav className="pointer-events-none fixed inset-x-0 bottom-0 z-50 hidden justify-center p-6 sm:flex">
      <div className="pointer-events-auto">
        <Dock items={items} />
      </div>
    </nav>
  )
}
